<div class="preview-wrapper animated fadeIn">
    <br>
    <br>
    <br>
    <br>
    <i class="bi bi-router"></i>
    <br>
    <br>
    <b>Automatically connect to a WiFi network</b>
</div>